const STORAGE_KEY = 'ab-experiments';

export type AssignedExperiment = {
  id: number;
  assignedVariant: number;
};

function isClient(): boolean {
  return typeof window !== 'undefined';
}

export function getStoredExperiments(): AssignedExperiment[] {
  if (!isClient()) return [];

  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

export function storeExperiments(experiments: AssignedExperiment[]): void {
  if (!isClient()) return;

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(experiments));
  } catch {}
}

export function storeVariant(experimentId: number, variant: number): void {
  const experiments = getStoredExperiments().filter(
    (exp) => exp.id !== experimentId,
  );
  experiments.push({ id: experimentId, assignedVariant: variant });
  storeExperiments(experiments);
}

export function getAssignedExperiments(): AssignedExperiment[] {
  return getStoredExperiments().filter(
    (exp) => exp.assignedVariant !== null && exp.assignedVariant >= 0,
  );
}

export function getAssignedExperimentsString(): string {
  return getAssignedExperiments()
    .map((exp) => `t${exp.id}v${exp.assignedVariant}`)
    .join(';');
}
